import { addIdsToArray, CustomButton, CustomColumn, CustomTableComponent } from 'src/app/components/table/custom-table/custom-table.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig   } from '@angular/material/dialog';
import { Calendar                     } from 'src/app/beans/calendar/calendar.bean';
import { CalendarDayFilter            } from 'src/app/beans/calendar/calendar.day.filter';
import { CalendarMin                  } from 'src/app/beans/calendar/calendar.min';
import { Device                       } from 'src/app/beans/device/device.bean';
import { User                         } from 'src/app/beans/login/user/user.bean';
import { Site                         } from 'src/app/beans/site/site.bean';
import { DeviceSelect                 } from 'src/app/components/select/device/device-select/device.select';
import { OrganizationSelect           } from 'src/app/components/select/organization/organization-select/organization.select';
import { SiteSelect                   } from 'src/app/components/select/site/site-select/site.select';
import { GenericDialog                } from 'src/app/dialogs/generic/generic.dialog';
import { TimeDialog                   } from 'src/app/dialogs/time/time.dialog';
import { DialogsReturnCode            } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager               } from 'src/app/managers/handler/handler.manager';
import { LoadingManager               } from 'src/app/managers/loading/loading.manager';
import { PipeManager                  } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager               } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'time.device.page',
  templateUrl: './time.device.page.html',
  styleUrls: ['./time.device.page.scss']
})

export class TimeDevicePage implements OnInit 
{
  orgSelect: OrganizationSelect
  @ViewChild('orgManager') set _orgSelect(orgSelect: OrganizationSelect){
    if (orgSelect){
      this.orgSelect = orgSelect
    }
  }
  site: Site
  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect){
    if (siteSelect){
      this.setSite(siteSelect.getSelectedValue())
    }
  }
  device: Device 
  @ViewChild('deviceManager') set _deviceSelect(deviceSelect: DeviceSelect){
    if (deviceSelect){
      this.setDevice(deviceSelect.getSelectedValue())
    }
  }

  @ViewChild('deviceTimeTable') deviceTimeTable: CustomTableComponent;


  values: CalendarMin[] = []

  timeServiceColumns: CustomColumn [] = [
    {
      isId    : true,
      label   : "id",
      name    : "id",
      display : ( val : any ) => false ,
    },
    {
      label         : "dow",
      name          : "tables.time.service.labels.dow",
      pipe          : (dow: any) => this._pipe.tables().get_week_day(dow),
    },
    {
      label         : "open",
      name          : "tables.time.service.labels.open",
    },
    {
      label         : "close",
      name          : "tables.time.service.labels.close",
    },
    {
      label         : "enabled",
      name          : "tables.time.service.labels.enabled",
      pipe          : (enabled: any) => this._pipe.tables().is_enabled(enabled),
    }
  ]

  days: CalendarDayFilter [] = [
    {
      name : "table.day.monday",
      dow  : 1,
    },
    {
      name : "table.day.tuesday",
      dow  : 2,
    },
    {
      name : "table.day.wednesday",
      dow  : 3,
    },
    {
      name : "table.day.thursday",
      dow  : 4,
    },
    {
      name : "table.day.friday",
      dow  : 5,
    },
    {
      name : "table.day.saturday",
      dow  : 6,
    },
    {
      name : "table.day.sunday",
      dow  : 7,
    },
  ]

  buttons: CustomButton[] = [
  {
      label : "enabled",
      column: "tables.time.generic.change_status",
      name  : "tables.time.generic.enable_disable",
      action: (el: any, pos: number) => {
        console.log("CHANGE");
        
        this.changeValues(el.calendarId, el.timeId, el.enabled)
      }
  }
  ]

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _pipe   : PipeManager   ,
    private _dialog : MatDialog     ,
  ) {}

  private calendarId: number

  ngOnInit(): void 
  {}

  setSite( site: Site )
  {    
    this.site = site
  }

  setDevice( device: Device )
  {    
    this.device = device
    this.init()
  }

  async init()
  {
    if( this.site && this.device )
    {
      let values = await this.retriveValues()
      let tempValues = []

      if( values )
      {
        let calendarId = values.calendarId
        this.calendarId = calendarId

        if( values.dows )
        {
          values.dows.forEach(element => {

            let dow = element.dow

            if ( element.times )
            {
              element.times.forEach(time => {
               
                let iTime = time
    
                 let calendarMin: CalendarMin = 
                 {
                  calendarId: calendarId,
                  dow       : dow,
                  timeId    : iTime.timeId,
                  open      : iTime.open,
                  close     : iTime.close,
                  enabled   : iTime.enabled
                 }
    
                 tempValues.push(calendarMin)
              });
            }
          });

          this.values = addIdsToArray ( tempValues )
        }
      }
      if( !this.values ) this.values = []
    }else{
      this.values = null
    }
  }

  //----------------------------------------------------------------------------------------
  
  create()
  {
    this.openDialog( "create", null )
  }

  async delete(item: any)
  {
    this.openDialog( "delete", item )
  }

  async changeValues(calendarId: number, timeId: number, enabled: number)
  {
    await this.changeStatus(calendarId, timeId, enabled)
    await this.init()
  }

  //----------------------------------------------------------------------------------------

  async openDialog( action: string, calendar: CalendarMin )
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    if( action && action != "delete" )
    {
      dialogConfig.data = {
        type          : "device"       ,
        generic       : this.device    ,
        calendarId    : this.calendarId,
        days          : this.days
      }

      dialog = this._dialog.open(TimeDialog, dialogConfig);
    }
    else if( action )
    {
      dialog = this._dialog.open(GenericDialog, dialogConfig);
    }
    else return

    dialog.afterClosed().subscribe(async (data: any) =>
    {
      //Delete message and refresh table data
      if (data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        await this.deleteTime(calendar.calendarId, calendar.timeId)
        await this.init()
      }

      //Refresh table data
      if (data.code == DialogsReturnCode.CALENDAR_OPERATION_ACCEPTED)
      {
        await this.init()
      }
    })
  }

  //----------------------------------------------------------------------------------------------

  async retriveValues() 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()
    this.deviceTimeTable.reloadData()
    let response = null

    response = await this._handler.device().calendar((user as User).token, this.device.id)

    this._loader.stop()
    this.deviceTimeTable.dataLoaded()
    if (!response) return
    if (!response.object) return

    return response.object as Calendar;
  }

  async changeStatus(calendarId: number, timeId: number, enabled: number) 
  {
    const user = this._session.user().get()

    if  (enabled === 0) enabled = 1
    else                enabled = 0

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.device().calendarStatus((user as User).token, this.device.id, calendarId, timeId, enabled)

    this._loader.stop()
  }

  async deleteTime(calendarId: number, timeId: number) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.device().deleteTime((user as User).token, this.device.id, calendarId, timeId)

    this._loader.stop()
  }

  //----------------------------------------------------------------------------------------------
}
